<template>
  <div>
    <Head title="Create City" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" :href="`/region/${region.id}/cities`">{{ region.name }}</Link>
      <span class="text-orange-400 font-medium">/</span> Create City
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-full" label="Name" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Create City</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>
    
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
    
export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    region: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        region: this.region.id,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(`/region/${this.region.id}/cities`)
    },
  },
}
</script>
    